// for errors outside vue components
// hm, sometimes, this leads to problems during console debugging
/*window.onerror = function(message, source, lineno, colno, error) {
    alert("Unexpected error - please contact support");
    throw error;
};*/

import App from './app.vue'
import {useUploadStore} from "./stores/upload-store";

import {createApp, h
    //, configureCompat
} from 'vue';
import {router} from './router';
import {createPinia} from 'pinia';
import filters from './filters';
import Vue3Lottie from "vue3-lottie";
import 'vue3-lottie/dist/style.css';
//import Vue3linkify from "vue-3-linkify";
import {SettingsService} from "./services/settings-service";
import {reportRequestError} from './utils/messaging.js';

import "bootstrap";

import i18n from './i18n';
const {t} = i18n.global;

import keycloak from './plugins/keycloak';
import {sleep} from "./utils/time";

/*
import {createI18n} from 'vue-i18n'
import de from './locales/de.json';
import en from './locales/en.json';
const i18n = createI18n({
    locale: 'de',
    messages: {de, en}
});
*/

//import draggable from 'vuedraggable';
//import VueCompositionApi from '@vue/composition-api';

import http from "./http-common";
import {setUploadStore} from "./http-common";

/* hm, VeeValidate together with i18n generated strange error messages like 
   'must be at least 1: characters'
   -> resort to using browser-validation mainly and manual for the rest, like here: https://vuejs.org/v2/cookbook/form-validation.html
Vue.use(VeeValidate, 
    {
    i18n,
    dictionary: {
        en: {
            messages: enValidation.messages,
            attributes: {mail: "e-mail"}
        },
        de: {
            messages: deValidation.messages,
            attributes: {mail: "mehail"}
        }
    }
 }   
);
 */


//Vue.use(VueCompositionApi);


//import Editor from "vue-editor-js/src";
//Vue.use(Editor);

/*configureCompat({
    RENDER_FUNCTION: false,
    ATTR_FALSE_VALUE: false
});*/

const app = createApp({
    render: () => h(App),
    // FIXME: probably handle with pinia
    onUpdateNumberOfNotifications: () => {
        this.loadNumberOfNotifications();
    }
});

export {app};

app.config.globalProperties.$filters = filters;

// for errors inside vue components that are not caught otherwise
app.config.errorHandler = async (err, vm, info) => {
    // ignore the more harmless ones
    if (err == 'AxiosError: Request aborted'){
        console.warn('ignoring uncaught error:', err);
    } else {
        console.error("uncaught error:", err);
        alert("Unexpected error - please contact support:" + err);
    }
    throw err;
};

app.use(createPinia());
setUploadStore(useUploadStore());
app.use(i18n);

// Shim for $tc (dropped in vue-i18n v10 Legacy API). See src/i18n.js for the tc() helper.
// $tc(key, count)          → $t(key, count)
// $tc(key, count, {named}) → $t(key, {named}, count)   ← reshuffled
app.config.globalProperties.$tc = function(key, arg1, arg2) {
    if (arg2 !== undefined && typeof arg1 === 'number' && arg2 !== null && typeof arg2 === 'object')
        return this.$t(key, arg2, arg1);
    return this.$t(key, arg1);
};
//app.use(draggable);

app.use(keycloak);

app.use(Vue3Lottie);

// no, garbles contents in v-for loop
//app.use(Vue3linkify);

// now set up keycloak
const keycloakInitOptions = {
    //onLoad: 'login-required'
    // check-sso not required, as we're calling login in router. skipping check-sso avoids getting the #error=login_required hash in the URL.
    //onLoad: 'check-sso', 
    checkLoginIframe: false
};

console.log("initializing keycloak...");
app.config.globalProperties.$keycloak.init(keycloakInitOptions)
    .then(async (isAuthenticated) => {
        console.log("initializing done, isAuthenticated = " + isAuthenticated);

        if (isAuthenticated){

            // this is the locale used for translating (operation language).
            var locale = app.config.globalProperties.$keycloak.idTokenParsed.locale || '';
            if (!locale)
                locale = import.meta.env.VITE_I18N_FALLBACK_LOCALE;

            i18n.global.locale = locale;

        } else {
            // take from lang parameter (our custom keycloak theme should equip links with that)
            if (location.search.includes("lang=")){
                const lang = location.search.replace(/.*lang=/, '').replace(/&.*/, '');
                i18n.global.locale = lang;
            } else
                console.warn("no language information!");
        }

        sessionStorage.removeItem('sessionId');
        /* used to check if login is fresh - now seems not worth it using sessionStorage for it, as we would need to inform, maybe even request consent (GDPR)
        if (app.config.globalProperties.$keycloak.idTokenParsed && 
            sessionStorage.sessionId != app.config.globalProperties.$keycloak.idTokenParsed.sid){
            sessionStorage.sessionId = app.config.globalProperties.$keycloak.idTokenParsed.sid;
            console.log("fresh login");

            // do tasks required after new login
            try {
                const userId = app.config.globalProperties.$keycloak.subject;
                await SettingsService.setAutoValues(userId);
            } catch (err){
                reportRequestError(err);
            }
        }
        */

        app.use(router);
        app.mount("#app");

        if (isAuthenticated){
            await app.config.globalProperties.$keycloak.checkTokenOrLogin();
            // used to do this just for fresh logins, now always:
            const userId = app.config.globalProperties.$keycloak.subject;
            await SettingsService.setAutoValues(userId);
        }

        //const development = import.meta.env.DEV;

        const serviceWorkerRegistration = await navigator.serviceWorker.register(
            /* Previously, we had Serviceworker script in src:
                   development ? '/src/custom-sw.js' : '/custom-sw.js',
               The problem with that approach was that scope was wrong then, leading to navigator.serviceWorker.controller = null in router.js, during DEV */
            '/custom-sw.js',
            {scope: '/'} // make sure global scope, which is required to get a non-null navigator.serviceWorker.controller in router.js during DEV. That scope is redundant now that we relocated the Serviceworker script, but keep it to make sure in case someone changes the location.
        );

        app.config.globalProperties.serviceWorkerRegistration = serviceWorkerRegistration;
    })
    .catch((err) => {
        console.error("error initializing keycloak:", err);
        if (navigator.onLine)
            alert(t('authentication.couldNotConnect'))
        else
            alert(t('authentication.couldNotConnectOffline'))
        location.reload();
    });

